module.exports = __webpack_public_path__ + "img/A03-20190232-001_b.bcd7c8df.jpg";